import { z } from 'zod';
/**
 * Counts of items the agent read at brief-generation time. The Source
 * Snapshot tab on brief-detail renders these. Reproducibility is the
 * product — same snapshot ⇒ same brief output.
 */
export const SourceSnapshotCounts = z.object({
    emails: z.number().int().nonnegative().default(0),
    calendar_events: z.number().int().nonnegative().default(0),
    doc_edits: z.number().int().nonnegative().default(0),
    slack_messages: z.number().int().nonnegative().default(0),
    salesforce_updates: z.number().int().nonnegative().default(0),
    stripe_events: z.number().int().nonnegative().default(0),
    github_events: z.number().int().nonnegative().default(0),
    notion_edits: z.number().int().nonnegative().default(0),
});
/**
 * Immutable record of source state per brief. Persisted at
 * `briefSourceSnapshots/{snapshotId}` and referenced from
 * `Brief.source_snapshot_id`. Re-running the agent on the same snapshot
 * id must produce the same brief — that's the reproducibility contract
 * (#166 Phase 4 — provenance & replay).
 */
export const SourceSnapshot = z.object({
    id: z.string(), // 'snap_2026w20_a3f1'
    orgId: z.string(),
    /** ISO timestamp the snapshot was taken. */
    snapshotAt: z.string().datetime(),
    counts: SourceSnapshotCounts,
    /**
     * Numbered reasoning steps the synthesis layer produced. Rendered as
     * the "agent reasoning trace" in the Source Snapshot tab.
     */
    reasoningTrace: z.array(z.string()).max(50).default([]),
    /** Storage size in bytes (informational, surfaced in the UI footer). */
    sizeBytes: z.number().int().nonnegative().default(0),
});
